import { CACHE_KEY } from '@gef-ui/cdu-user-v2/constants';
import { transformPermissions } from '@gef-ui/cdu-user-v2/utils';
import { getRequestCache } from '@gef-ui/middleware-api/redux/cache/selectors';
import path from "ramda/es/path";
import compose from "ramda/es/compose";
import prop from "ramda/es/prop";
import { createSelector } from 'reselect';
const cachePath = path([
    'cache',
    CACHE_KEY,
    'data',
    'body'
]);
export const getCduUser = createSelector(getRequestCache, cachePath);
export const getCduUserPermissions = createSelector(getCduUser, compose(prop('permissions'), transformPermissions));
